/* tslint:disable:jsx-no-lambda WI:47781 */
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { IContextualMenuProps } from 'office-ui-fabric-react/lib/ContextualMenu';
import { IIconProps } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';

// Remark: We have to share css file with MailListItem since we need to trigger child hover selectors
// off of the MailListItem container css class
const classNames = require('classnames/bind').bind();

export interface IconBarProps {
    hoverActionIcons: HoverActionIconProps[];
    propertyIcons: PropertyIconProps[];
    iconClass: string;
    propertyIconClass: string;
    hoverIconClass: string;
}

export interface HoverActionIconProps extends PropertyIconProps {
    title: string; // Title of icon when hovered over
    iconProps: IIconProps;
    menuProps?: IContextualMenuProps;
    onClickCommand?: () => void;
    onContextMenu?: (evt: React.MouseEvent<unknown>) => void;
}

export interface PropertyIconProps {
    iconClasses: string; // Css classes for the icon
    key: string; // Key for the React virtual DOM
}

/*
Renders the bar for both action icons and property icons
Note: This is a pure presentational component, and as such renders only based on passed in props
and do not observe the mobX store. It is a PureComponent so that it only rerenders if the props have changed (shallow compare).
*/
export default class IconBar extends React.PureComponent<IconBarProps, {}> {
    private renderPropertyIcons(): JSX.Element[] {
        const propertyIconElements: JSX.Element[] = [];

        this.props.propertyIcons.forEach(propertyIcon => {
            const iconClasses = classNames(
                this.props.iconClass,
                this.props.propertyIconClass,
                propertyIcon.iconClasses
            );
            propertyIconElements.push(<span key={propertyIcon.key} className={iconClasses} />);
        });

        return propertyIconElements;
    }

    private renderHoverIcons(): JSX.Element[] {
        const hoverIconElements = [];
        this.props.hoverActionIcons.forEach(hoverActionIcon => {
            const iconClasses = classNames(this.props.iconClass, this.props.hoverIconClass);
            hoverIconElements.push(
                <IconButton
                    key={hoverActionIcon.key}
                    iconProps={hoverActionIcon.iconProps}
                    onClick={(evt: React.MouseEvent<unknown>) => {
                        evt.stopPropagation();
                        hoverActionIcon.onClickCommand();
                    }}
                    onDoubleClick={(evt: React.MouseEvent<unknown>) => {
                        evt.stopPropagation();
                    }}
                    onRenderMenuIcon={() => null}
                    styles={{ root: iconClasses }}
                    title={hoverActionIcon.title}
                    ariaLabel={hoverActionIcon.title}
                    menuProps={hoverActionIcon.menuProps}
                    onContextMenu={evt => {
                        if (hoverActionIcon.onContextMenu) {
                            hoverActionIcon.onContextMenu(evt);
                        }
                    }}
                />
            );
        });

        return hoverIconElements;
    }

    render() {
        return (
            <>
                {this.renderHoverIcons()}
                {this.renderPropertyIcons()}
            </>
        );
    }
}
